import { styled } from "styled-components";

export const EducationContainer = styled.div``;

export const EducationWrapper = styled.div`
  padding: 80px 0;
  @media all and (max-width: 768px) {
    padding: 9.115vw 0;
  }
`;

export const EducationWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 80px;
  .title-wrap {
    display: flex;
    flex-direction: column;
    gap: 40px;
    h6 {
      font-size: 32px;
      line-height: 1.3;
      font-weight: bold;
      color: #233e99;
    }
    p {
      color: #171717;
      font-size: 24px;
      line-height: 1.3;
      word-break; keep-all;
    }
  }
  .goals-wrap {
    display: flex;
    flex-direction: column;
    gap: 40px;
    > p {
      font-size: 32px;
      line-height: 1.3;
      color: #242424;
      font-weight: bold;
    }
    ul {
      display: flex;
      gap: 32px;
      li {
        width: calc(33.333% - 64px / 3);
        height: 128px;
        background: #efefef;
        border-radius: 8px;
        font-size: 24px;
        line-height: 1.3;
        color: #233e99;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  > p {
    font-size: 24px;
    line-height: 1.3;
    color: #171717;
    word-break: keep-all;
  }
  @media all and (max-width: 1024px) {
    > p {
      br {
        display: none;
      }
    }
  }
  @media all and (max-width: 900px) {
    .title-wrap {
      p {
        .pc-br {
          display: none;
        }
      }
    }
    .goals-wrap {
      ul {
        gap: 20px;
        flex-wrap: wrap;
        justify-content: center;
        li {
          width: calc(50% - 10px);
        }
      }
    }
  }
  @media all and (max-width: 768px) {
    gap: 10.417vw;
    .title-wrap {
      gap: 5.208vw;
      h6 {
        font-size: 4.948vw;
      }
      p {
        font-size: 3.906vw;
      }
    }
    .goals-wrap {
      gap: 5.208vw;
      > p {
        font-size: 5.208vw;
      }
      ul {
        gap: 2.604vw;
        li {
          width: calc(50% - 1.302vw);
          height: 18.88vw;

          border-radius: 1.042vw;
          font-size: 3.646vw;
        }
      }
    }
    > p {
      font-size: 3.646vw;
    }
  }
`;
